import { type FC } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import { trackItemFavoritingSuccessToastCtaClick } from './tracking';

import styles from './styles/PortfolioToast.scss';
import sharedStyles from './styles/shared.scss';
import dibsCss from 'dibs-css';

const AddToFavoritesToastContent: FC = () => (
    <div className={classNames(dibsCss.flex, dibsCss.flexCol, dibsCss.gap2px)}>
        <div
            className={classNames(
                dibsCss.flex,
                dibsCss.justifyBetween,
                dibsCss.itemsCenter,
                dibsCss.gapSmall
            )}
        >
            <span className={dibsCss.sassyFontBodySmallHeavy}>
                <FormattedMessage
                    id="itemFavoriting.FavoritesToastsContent.add.body"
                    defaultMessage="Saved To Your Favorites"
                />
            </span>
            <Link
                href="/favorites/items/"
                target="_blank"
                className={classNames(styles.link, dibsCss.sassyFontBodySmallHeavy)}
                onClick={() =>
                    trackItemFavoritingSuccessToastCtaClick({ trigger: 'view favorites' })
                }
            >
                <FormattedMessage
                    id="itemFavoriting.FavoritesToastsContent.add.link"
                    defaultMessage="View Favorites"
                />
            </Link>
        </div>
        <span className={classNames(sharedStyles.hideMobile, dibsCss.sassyFontBodySmall)}>
            <FormattedMessage
                id="itemFavoriting.FavoritesToastsContent.add.disclaimer"
                defaultMessage="We’ll notify you about price drops and exclusive offers."
            />
        </span>
    </div>
);

const RemoveFromFavoritesToastContent: FC = () => (
    <div className={classNames(dibsCss.flex, dibsCss.itemsCenter, dibsCss.sassyFontBodySmallHeavy)}>
        <FormattedMessage
            id="itemFavoriting.FavoritesToastsContent.remove.body"
            defaultMessage="Removed From Favorites"
        />
    </div>
);

export { AddToFavoritesToastContent, RemoveFromFavoritesToastContent };
